import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import SavedProductDesignLoader from './SavedProductDesignLoader';
import saveProductDesignAlertDispatch from '../actions/saveProductDesignAlert';

const mapDispatchToProps = (dispatch) => {
  const actions = bindActionCreators({ saveProductDesignAlertDispatch }, dispatch);
  return { ...actions, dispatch };
};

export default connect(
  null,
  mapDispatchToProps,
)(SavedProductDesignLoader);
